import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
const SvgComponent = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={29}
    viewBox="0 0 29 29"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#444697'}
      d="M27.28 1.83A4.673 4.673 0 0 0 23.202.55c-.93.16-1.8.62-2.5 1.33l-7.85 7.85a5.588 5.588 0 0 0-1.65 3.99v1.18c0 1.66 1.35 3.02 3.02 3.02h1.18c1.51 0 2.93-.59 3.99-1.65l7.85-7.85c.71-.71 1.17-1.57 1.33-2.5.26-1.51-.2-3-1.29-4.08v-.01Zm-1.21 3.65v.08c-.1.38-.309.75-.619 1.07l-7.85 7.85c-.59.59-1.37.91-2.21.91h-1.18a.49.49 0 0 1-.49-.49v-1.18c0-.83.32-1.62.91-2.21l7.85-7.85c.34-.34.74-.56 1.15-.63.13-.02.25-.03.38-.03.56 0 1.09.22 1.48.62.49.49.7 1.17.58 1.86ZM7.24 21.479c0 .7.57 1.26 1.26 1.26h9.21c.7 0 1.26-.57 1.26-1.26 0-.69-.57-1.26-1.26-1.26H8.5c-.7 0-1.26.57-1.26 1.26Z"
    />
    <Path
      fill={props.fill || '#444697'}
      d="M24.2 17.15h-.03c-.64.06-1.14.651-1.14 1.331v5.19c0 1.24-1.01 2.25-2.25 2.25H5.43c-1.24 0-2.25-1.01-2.25-2.25V8.75c0-1.24 1.01-2.25 2.25-2.25h4.75c.69 0 1.27-.5 1.33-1.14.04-.36-.08-.71-.32-.98s-.58-.42-.94-.42H5.42C2.79 3.96.65 6.1.65 8.73v14.92c0 2.54 1.99 4.62 4.5 4.77l15.63.01c2.63 0 4.77-2.14 4.77-4.77v-5.27c0-.36-.15-.7-.42-.93-.23-.21-.52-.32-.95-.32l.02.01Z"
    />
  </Svg>
);
export default SvgComponent;
